const UserActions = {
    UPDATE_USER: 'UPDATE_USER',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
}

export default UserActions;